<template>
	<div>
		<CCard>
			<CCardHeader>Retirer/Supprimer un bordereau</CCardHeader>
			<CCardBody>
				<p>Indiquez le numéro du bordereau à retirer d'un point de vente.</p>

				<CCol col="4">
					<CInput v-model="identifier" label="Numéro de bordereau à retirer" />

					<CButton color="primary" @click="onSubmit">Retirer</CButton>
				</CCol>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	export default {
		name: 'remove',

		data() {
			return {
				identifier: null,
			};
		},

		methods: {
			onSubmit() {
				this.$axios
					.delete(`/api/slips/${this.identifier}`)
					.then(res => {
						if (res.status === 204) {
							this.$toast.success(`Bordereau ${this.identifier} supprimé.`);
							this.identifier = null;
						}
					})
					.catch(err => {
						if (err.response.status === 404) {
							this.$toast.error(`Le bordereau ${this.identifier} n'a pas été trouvé.`);
						} else {
							this.$toast.error('Un problème est survenu.');
						}
					});
			},
		},
	};
</script>

<style scoped></style>
